(function($, undefined) {
	'use strict';

	var init = function() {
		$('.com-faq__item-head').on('click', onItemHeadClick);

		initOpenItemByAnchor();
	};

	function onItemHeadClick() {
		var itemHead = $(this);
		var component = itemHead.closest('.com-faq');
		var item = itemHead.closest('.com-faq__item');
		var body = $('.com-faq__item-body', item);

		toggleItem(item);
		changeBrowserUrlAnchor(item.attr("id"));
	}

	function changeBrowserUrlAnchor(anchor) {
		var url = location.href;
		var urlWithoutAnchor = url.split('#')[0];
		anchor = anchor.indexOf('#') !== -1 ? anchor : '#' + anchor;

		history.replaceState({}, document.title, urlWithoutAnchor + anchor);
	}

	function initOpenItemByAnchor() {
		var url = location.href;
		var anchor = url.split('#')[1];

		if (anchor) {
			toggleItem($('.com-faq__item[id=' + anchor + ']'));
		}
	}

	function toggleItem(item) {
		var component = item.closest('.com-faq');
		var body = $('.com-faq__item-body', item);

		if (item.hasClass('com-faq__item_open')) {
			body.slideUp(300);
		} else {
			$('.com-faq__item-body', component).slideUp(300);
			$('.com-faq__item', component).removeClass('com-faq__item_open');
			body.slideDown(300);
		}

		item.toggleClass('com-faq__item_open');
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
